var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.802,
    height: 200.988,
    viewBox: "0 0 155.802 200.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22349",
    "data-name": "Group 22349",
    transform: "translate(-849.344 -203.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11473",
    "data-name": "Path 11473",
    d: "M99.175,352.121c0,4.145-22.2,7.5-49.588,7.5S0,356.266,0,352.121s22.2-7.5,49.588-7.5,49.588,3.36,49.588,7.5",
    transform: "translate(905.97 44.531)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22348",
    "data-name": "Group 22348",
    transform: "translate(-619.012 -102.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11433",
    "data-name": "Path 11433",
    d: "M1477.219,698.807H1539.3c4.488,0,9.21,4.736,9.21,9.21V813.758c0,4.474-3.677,8.861-8.153,8.861h-63.848a8.188,8.188,0,0,1-8.158-8.158v-107.5C1468.356,702.477,1472.729,698.807,1477.219,698.807Z",
    transform: "translate(0 -336.694)",
    fill: "#e2e9fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11434",
    "data-name": "Path 11434",
    d: "M1487.582,726.461h61.382a6.325,6.325,0,0,1,6.306,6.3V838.153a6.325,6.325,0,0,1-6.306,6.306h-61.382a6.322,6.322,0,0,1-6.306-6.306V732.765A6.322,6.322,0,0,1,1487.582,726.461Z",
    transform: "translate(-11.069 -360.385)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11435",
    "data-name": "Path 11435",
    d: "M1533.2,987.684h12.05a1.546,1.546,0,0,1,1.544,1.54v3.363a1.547,1.547,0,0,1-1.544,1.542H1533.2a1.545,1.545,0,0,1-1.542-1.542v-3.363a1.544,1.544,0,0,1,1.542-1.54Zm44.42,0h12.055a1.543,1.543,0,0,1,1.537,1.54v3.363a1.544,1.544,0,0,1-1.537,1.542h-12.055a1.547,1.547,0,0,1-1.544-1.542v-3.363a1.546,1.546,0,0,1,1.544-1.54Zm-22.211,0h12.052a1.541,1.541,0,0,1,1.54,1.54v3.363a1.541,1.541,0,0,1-1.54,1.542h-12.052a1.547,1.547,0,0,1-1.544-1.542v-3.363A1.546,1.546,0,0,1,1555.414,987.684Z",
    transform: "translate(-54.235 -584.176)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11436",
    "data-name": "Path 11436",
    d: "M1578.016,1083.943h11.272a1.939,1.939,0,0,1,1.929,1.936v7.171a1.937,1.937,0,0,1-1.929,1.931h-11.272a1.938,1.938,0,0,1-1.936-1.931v-7.171a1.941,1.941,0,0,1,1.936-1.936Zm-44.418,0h11.265a1.941,1.941,0,0,1,1.936,1.936v7.171a1.938,1.938,0,0,1-1.936,1.931H1533.6a1.935,1.935,0,0,1-1.936-1.931v-7.171a1.938,1.938,0,0,1,1.936-1.936Zm22.207,0h11.27a1.937,1.937,0,0,1,1.931,1.936v7.171a1.934,1.934,0,0,1-1.931,1.931h-11.27a1.938,1.938,0,0,1-1.936-1.931v-7.171A1.941,1.941,0,0,1,1555.805,1083.943Z",
    transform: "translate(-54.235 -666.642)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11437",
    "data-name": "Path 11437",
    d: "M1578.016,1198.781h11.272a1.938,1.938,0,0,1,1.929,1.931v7.176a1.937,1.937,0,0,1-1.929,1.929h-11.272a1.938,1.938,0,0,1-1.936-1.929v-7.176a1.94,1.94,0,0,1,1.936-1.931Zm-44.418,0h11.265a1.94,1.94,0,0,1,1.936,1.931v7.176a1.938,1.938,0,0,1-1.936,1.929H1533.6a1.935,1.935,0,0,1-1.936-1.929v-7.176a1.937,1.937,0,0,1,1.936-1.931Zm22.207,0h11.27a1.936,1.936,0,0,1,1.931,1.931v7.176a1.934,1.934,0,0,1-1.931,1.929h-11.27a1.938,1.938,0,0,1-1.936-1.929v-7.176A1.94,1.94,0,0,1,1555.805,1198.781Z",
    transform: "translate(-54.235 -765.024)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11438",
    "data-name": "Path 11438",
    d: "M1533.6,1313.586h11.265a1.942,1.942,0,0,1,1.936,1.936v7.173a1.938,1.938,0,0,1-1.936,1.931H1533.6a1.935,1.935,0,0,1-1.936-1.931v-7.173a1.939,1.939,0,0,1,1.936-1.936Zm22.207,0h11.27a1.938,1.938,0,0,1,1.931,1.936v7.173a1.934,1.934,0,0,1-1.931,1.931h-11.27a1.938,1.938,0,0,1-1.936-1.931v-7.173A1.942,1.942,0,0,1,1555.805,1313.586Z",
    transform: "translate(-54.235 -863.378)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11439",
    "data-name": "Path 11439",
    d: "M1578.016,1313.586h11.272a1.941,1.941,0,0,1,1.929,1.936v23.629a1.936,1.936,0,0,1-1.929,1.928h-11.272a1.938,1.938,0,0,1-1.936-1.928v-23.629a1.942,1.942,0,0,1,1.936-1.936Zm-44.418,16.456h11.265a1.943,1.943,0,0,1,1.936,1.936v7.173a1.938,1.938,0,0,1-1.936,1.928H1533.6a1.935,1.935,0,0,1-1.936-1.928v-7.173a1.939,1.939,0,0,1,1.936-1.936Zm22.207,0h11.27a1.939,1.939,0,0,1,1.931,1.936v7.173a1.934,1.934,0,0,1-1.931,1.928h-11.27a1.938,1.938,0,0,1-1.936-1.928v-7.173A1.942,1.942,0,0,1,1555.805,1330.042Z",
    transform: "translate(-54.235 -863.378)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11440",
    "data-name": "Path 11440",
    d: "M1503.813,778h67.536V752.086a3.084,3.084,0,0,0-3.077-3.072H1506.89a3.084,3.084,0,0,0-3.077,3.072Z",
    transform: "translate(-30.376 -379.706)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11441",
    "data-name": "Path 11441",
    d: "M1532.927,812.516h57.284a1.073,1.073,0,0,1,1.066,1.071v8.09a1.071,1.071,0,0,1-1.066,1.071h-57.284a1.072,1.072,0,0,1-1.068-1.071v-8.09A1.073,1.073,0,0,1,1532.927,812.516Z",
    transform: "translate(-54.403 -434.109)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11443",
    "data-name": "Path 11443",
    d: "M1835.736,666.263H1824.19c-2.559,8.509-5.528,13.564-11.239,13.564h37.022c5.708,0,8.678-5.055,11.237-13.564Z",
    transform: "translate(-295.216 -308.814)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11444",
    "data-name": "Path 11444",
    d: "M1601.609,315.511h50.9c-.588-5.848-2.055-9.715-5.6-9.715h-37.734Q1604.687,306.149,1601.609,315.511Z",
    transform: "translate(-114.159)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11445",
    "data-name": "Path 11445",
    d: "M1704.136,357.449c-4.731-19.11,2.521-51.653-7.776-51.653h-37.022c14.576,0-6.023,65.217,22.012,65.217,5.711,0,8.68-5.055,11.239-13.564Z",
    transform: "translate(-163.616)",
    fill: "#d3e3f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11446",
    "data-name": "Path 11446",
    d: "M1682.619,370.924c-25.434-2.676-6.013-65.128-20.278-65.128h-3c14.576,0-6.023,65.217,22.012,65.217A8.546,8.546,0,0,0,1682.619,370.924Z",
    transform: "translate(-163.616)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11447",
    "data-name": "Path 11447",
    d: "M1912.032,357.449c-4.729-19.11,2.524-51.653-7.773-51.653h-2.407c10.3,0,3.044,32.544,7.776,51.653Z",
    transform: "translate(-371.378)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11448",
    "data-name": "Path 11448",
    d: "M1857.924,668.773c-2.4,6.984-5.313,11.054-10.431,11.054h2.2c5.708,0,8.677-5.055,11.237-13.564H1821.64c-2.205,7.33-4.713,12.1-9.015,13.278q.636.127,1.315.2c4.35-.628,6.979-4.579,9.17-10.965Z",
    transform: "translate(-294.936 -308.814)",
    fill: "#d2e5f7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11449",
    "data-name": "Path 11449",
    d: "M1604.107,315.511q2.815-8.572,6.815-9.59a4.23,4.23,0,0,0-1.04-.124h-.713q-4.482.353-7.56,9.715Z",
    transform: "translate(-114.159)",
    fill: "#d3e3f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11450",
    "data-name": "Path 11450",
    d: "M1740.12,331.333h22.771a.851.851,0,0,1,.848.846h0a.853.853,0,0,1-.848.848H1740.12a.85.85,0,0,1-.843-.848h0a.848.848,0,0,1,.843-.846Zm1.631,21.753h22.682a.851.851,0,0,1,.848.848h0a.852.852,0,0,1-.848.848h-22.682a.852.852,0,0,1-.848-.848h0a.851.851,0,0,1,.848-.848Zm0-3.366h22.682a.852.852,0,0,1,.848.851h0a.851.851,0,0,1-.848.846h-22.682a.85.85,0,0,1-.848-.846h0a.852.852,0,0,1,.848-.851Zm0-5.726h14.44a.846.846,0,0,1,.844.848h0a.845.845,0,0,1-.844.846h-14.44a.849.849,0,0,1-.848-.846h0a.849.849,0,0,1,.848-.848Zm-.255-3.165h22.764a.85.85,0,0,1,.848.848h0a.851.851,0,0,1-.848.846H1741.5a.853.853,0,0,1-.851-.846h0a.852.852,0,0,1,.851-.848Zm-.258-3.165h22.767a.849.849,0,0,1,.848.846h0a.851.851,0,0,1-.848.848h-22.767a.851.851,0,0,1-.848-.848h0a.849.849,0,0,1,.848-.846Zm-.56-3.167h22.771a.851.851,0,0,1,.848.848h0a.852.852,0,0,1-.848.848h-22.771a.852.852,0,0,1-.848-.848h0A.851.851,0,0,1,1740.678,334.5Z",
    transform: "translate(-232.099 -21.878)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11451",
    "data-name": "Path 11451",
    d: "M2161.213,800.612c2.365-3.458-2.746-4.345-2.692-8.135.03-2.609-1.608-5.329-1.112-7.932,1-5.325-1.076-6.945-1.088-7.346-.126-4.041-2.546-4.142-4.946-5.505-4.265-2.415-7.973.538-9.187.618-6.163.4-2.753,3.052-5.508,5.439-2.271,1.969-1.2,3.461-.965,4.644.107.532.6,2.726-.974,3.834-2.307,1.626.06,5.968-1.3,6.38-5.239,1.587-3.135,2.238-2.991,5.9.047,1.171,1.177,2.059,1.912,2.92C2141.382,798.606,2147.589,809.834,2161.213,800.612Z",
    transform: "translate(-560.111 -434.88)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11452",
    "data-name": "Path 11452",
    d: "M2214.8,902.209a3.43,3.43,0,0,0-1.216-1.2,17.7,17.7,0,0,1-8.281,2.307,47.231,47.231,0,0,0,.679,5.266Q2213.183,902.986,2214.8,902.209Z",
    transform: "translate(-621.722 -541.337)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11453",
    "data-name": "Path 11453",
    d: "M2187.6,902.842a17.749,17.749,0,0,0-1.431,4.175,5.566,5.566,0,0,1,3.5-2.86c-.6-.634-.553-1.456-.8-2.119Q2187.847,902.661,2187.6,902.842Z",
    transform: "translate(-606.084 -542.179)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11454",
    "data-name": "Path 11454",
    d: "M2141.228,906.5c-7.25,18.424-1.142,16.993,14.566.4a16.385,16.385,0,0,1,2.526.81q-3.058,2.828-2.289,9.456.466,5.133,1.016,9.979a16.758,16.758,0,0,0-1.426,6.309,26.268,26.268,0,0,0,.625,6.279,87.2,87.2,0,0,0,3.924,12.459q-16.488,5.613-28.232.126c4.542-9.979,3.941-13.072,3.424-19.748-.516-10.837-7.122-7.436,3.859-25.657A9.473,9.473,0,0,1,2141.228,906.5Z",
    transform: "translate(-561.765 -545.827)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11455",
    "data-name": "Path 11455",
    d: "M2173.341,907.607a47.27,47.27,0,0,0,.678,5.266q7.2-5.595,8.819-6.372c.329.06.643.128.953.2-15.707,16.6-21.816,18.027-14.566-.4a13.841,13.841,0,0,1,2.05-.012,17.717,17.717,0,0,0-1.432,4.175A5.568,5.568,0,0,1,2173.341,907.607Z",
    transform: "translate(-589.762 -545.629)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11456",
    "data-name": "Path 11456",
    d: "M2226.635,939.02q4.478.014,8.353-.335-1.007-7.67-1.772-16.12-.766-6.631,2.29-9.456a8.4,8.4,0,0,1,5.178,5.362c1.605,5.176,1.408,24.461-.334,26.2q-3.308,1.448-13.968-.589A10.331,10.331,0,0,0,2226.635,939.02Z",
    transform: "translate(-638.951 -551.228)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11457",
    "data-name": "Path 11457",
    d: "M2169.409,1042.257c.406.042,1.042.084,1.916.12a10.381,10.381,0,0,1-.156,3.481q-1.147-.21-2.9-.607a16.966,16.966,0,0,1-7.51-.084q-3.058-1.175-1.859-4.3,4.779.556,5.717-.359c-1.112-.568-1.5-1.222-1.183-1.96Q2168.137,1040.257,2169.409,1042.257Z",
    transform: "translate(-583.526 -653.741)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11458",
    "data-name": "Path 11458",
    d: "M2059.166,1012.223l-22.279-3.377,4.808,9.623,22.322,3.5-.356-.711c-.75-.081-1.527-.2-2.343-.365q-3.057-1.174-1.858-4.3c.722.084,1.377.144,1.966.176Z",
    transform: "translate(-484.084 -629.467)",
    fill: "#e2e9fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11460",
    "data-name": "Path 11460",
    d: "M2186.232,1076.852l-2.475.64-.355-.711A17.57,17.57,0,0,0,2186.232,1076.852Z",
    transform: "translate(-603.826 -684.989)",
    fill: "#859ac6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11461",
    "data-name": "Path 11461",
    d: "M2085.335,1065.008l2.474-.639a12.119,12.119,0,0,0,2.337-.353c.783.176,1.479.329,2.08.448l-6.171,2.02-6.088-1.034-17-2.887.041-1.058,16.317,2.561h0Z",
    transform: "translate(-505.402 -672.506)",
    fill: "#e2e9fb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11462",
    "data-name": "Path 11462",
    d: "M2129.042,1010.065a11.212,11.212,0,0,0,2.193-2.854,34.416,34.416,0,0,1,1.13,3.356Z",
    transform: "translate(-559.399 -628.132)",
    fill: "#6d96ce",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11463",
    "data-name": "Path 11463",
    d: "M2147.6,908.743a73.14,73.14,0,0,0-5.132,9.722C2141.534,911.149,2142.873,909.505,2147.6,908.743Z",
    transform: "translate(-570.143 -547.66)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11464",
    "data-name": "Path 11464",
    d: "M2148.968,1159.6q3.9,8.033,2.194,34.913-21.383,2.9-30.805-.589.766-24.548,3.46-34.174Q2134.509,1164.077,2148.968,1159.6Z",
    transform: "translate(-552.301 -752.672)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11465",
    "data-name": "Path 11465",
    d: "M2193.458,831.04a17.7,17.7,0,0,1-8.281,2.307,3.839,3.839,0,0,1-.72-1.877c-.012-.033-.018-.066-.03-.1a2.114,2.114,0,0,0,.475-2.122c-.006-.015-.006-.033-.012-.048-3.144-1.055-5.092-6.339-3.816-9.45-.066-1.04-.165-2.119-.3-3.234,4.654,1.348,7.579,1.276,10.992-1.123a6.055,6.055,0,0,1,.541,4.073c-.078.568-.371,1.775.386,1.886.349-1.963,1.07-3.051,2.4-2.582,1.18,1.892.476,4.277-2.367,4.773-.833,1.721-1.2,2.9-1.076,3.532-.09,1.076.849,2.519,1.557,3.577C2193.291,830.792,2193.381,830.92,2193.458,831.04Z",
    transform: "translate(-601.6 -471.369)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11466",
    "data-name": "Path 11466",
    d: "M2203.633,888.375a7.637,7.637,0,0,0,4.531-.5,6.562,6.562,0,0,1-4.483,1.886A2.957,2.957,0,0,0,2203.633,888.375Z",
    transform: "translate(-620.36 -530.606)",
    fill: "#ed7d57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11467",
    "data-name": "Path 11467",
    d: "M2128.143,1366.157q-.552-7.58-.654-16.069a44.293,44.293,0,0,0,11.879,1.417c-1.147,4.844-2.89,10.146-3.8,15.382,4.827,13.092-1.82,23.905-.875,32.465-1.312,2.1-3.5,6.838-6.793,8.577-1.094-.283-.274-1.282-.642-1.853q2.551-2.649,3.191-8.3A160.691,160.691,0,0,0,2128.143,1366.157Z",
    transform: "translate(-557.942 -908.352)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11468",
    "data-name": "Path 11468",
    d: "M2211.909,1366.489c-.992-4.142-2.8-8.311-4.106-12.809q5.267-.126,11.726-.894-.1,6.379-.164,13.3c6.757,11.948,2.235,25.908,4.034,31.918-1.312,3.12-1.664,7.032-4.587,9.33-1.082-.08-.523-1.132-.93-1.634a20.849,20.849,0,0,0,1.512-7.851Q2217.835,1384.328,2211.909,1366.489Z",
    transform: "translate(-623.768 -910.556)",
    fill: "#f9af79",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11469",
    "data-name": "Path 11469",
    d: "M2089.235,1624.212c2.313.12.2,1.862,1.706,2.253,3.3-1.739,5.116-6.485,6.438-8.583.69-1.1,1.195.3,1.533,1.874.541,2.5-.144,1.623-.452,3.619-.077.5.565,3.18.673,4.665a1.158,1.158,0,0,1-.341.923c-.6-1.016-1.117-4.139-1.671-6.046-3.227,2.776-2.525,5.843-4.441,6.882-4.6.493-7.086.619-10.579.691C2081.333,1627.625,2087.409,1628.593,2089.235,1624.212Z",
    transform: "translate(-520.982 -1126.889)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11470",
    "data-name": "Path 11470",
    d: "M2230.751,1605.8c2.226-.281.532,1.743,2.044,1.859,2.83-2.22,3.7-7.067,4.575-9.291.457-1.168,1.2.084,1.808,1.524.975,2.293.161,1.581.233,3.536.018.487,1.118,2.944,1.491,4.345a1.107,1.107,0,0,1-.156.936c-.759-.87-1.825-3.766-2.7-5.487-2.579,3.2-1.348,6.01-2.989,7.334-4.3,1.249-6.652,1.79-9.975,2.457C2223.83,1610.4,2229.8,1610.3,2230.751,1605.8Z",
    transform: "translate(-637.751 -1110.89)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11471",
    "data-name": "Path 11471",
    d: "M2099.8,1038.414c-.415,0-.56.342-.316.761a1.569,1.569,0,0,0,1.2.757c.419,0,.56-.338.316-.757A1.568,1.568,0,0,0,2099.8,1038.414Z",
    transform: "translate(-540.589 -627.637)",
    fill: "#9db2d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11472",
    "data-name": "Path 11472",
    d: "M1592.6,690.334a2.8,2.8,0,1,1,4.821-2.845l4.5,7.569,16.46-19.8a2.792,2.792,0,0,1,4.293,3.572l-18.86,22.689a2.883,2.883,0,0,1-.853.783,2.8,2.8,0,0,1-3.836-.987Z",
    transform: "translate(-106.109 -315.655)",
    fill: "#040227",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/Billing.86054d1e67cffa2bb5c41425b0ba2518.svg";
export { ForwardRef as ReactComponent };